import _ from 'underscore';

function CancelAdmissionGroupPanelCtrl($scope, $panelInstance, venue, date, type, admissionGroup, colorService, admissionGroupService, alertService, sdkUtils) {
  _initScope();

  function _initScope() {
    $scope.admissionGroup = admissionGroup;
    $scope.loading = false;
    $scope.venue = venue;
    $scope.venueBrandColors = $scope.venue.branding ? {
      primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : null //eslint-disable-line
    } : {};
    $scope.date = date;
    $scope.type = type;

    $scope.cancellationReasons = [{
      key: 'Venue Cancelled',
      value: 'VENUE'
    }, {
      key: 'Guest Cancelled',
      value: 'USER'
    }, {
      key: 'No Show',
      value: 'NO_SHOW'
    }, {
      key: 'Fraud',
      value: 'FRAUD'
    }, {
      key: 'Mistake',
      value: 'MISTAKE'
    }, {
      key: 'Duplicate',
      value: 'DUPLICATE'
    }, {
      key: 'Inquiry Declined',
      value: 'INQUIRY_DECLINED'
    }];

    $scope.cancelForm = {
      cancelledReasonType: $scope.cancellationReasons[0].value,
      refund: true
    };

    $scope.cancelAdmissionGroup = function(angularForm, $event) {
      if ($event) $event.preventDefault();

      $scope.submitted = true;

      if (!angularForm.$valid) return null;

      $scope.saving = true;

      const data = _.extend({}, $scope.cancelForm);
      data.type = 'CANCEL';

      return admissionGroupService.performActionById($scope.admissionGroup.id, data)
        .then(result => {
          $panelInstance.close({
            admissionGroup: result,
            cancelled: true
          });

          $scope.saving = false;
        })
        .catch(error => {
          $scope.saving = false;

          alertService.error(sdkUtils.getErrorFromResponse(error));
        });
    };

    $scope.closePanel = function($event) {
      if ($event) $event.preventDefault();

      $panelInstance.close(false);
    };
  }
}

CancelAdmissionGroupPanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'type',
  'admissionGroup',
  'colorService',
  'jsSdk.admissionGroup',
  'alertService',
  'jsSdk.utils'
];

export default CancelAdmissionGroupPanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/cancelAdmissionGroup/controller.js